import warning from 'warning';
var warned = {};
export default (function (valid, message) {
  if (!valid && !warned[message]) {
    warning(false, message);
    warned[message] = true;
  }
});


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/_util/warning.js
// module id = 23
// module chunks = 0